import OwnRepaymentGA from './OwnRepaymentGA'

export { OwnRepaymentGA }
